import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4cf82ed6&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=4cf82ed6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf82ed6",
  null
  
)

export default component.exports